// Keeps the free-shipping progress bar in sync with the cart. The server
// renders the initial state (snippets/free-shipping-bar.liquid); after any
// cart change (add to cart, quantity change, removal) we re-read /cart.js.
class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.threshold = Number(this.dataset.threshold);
    this.moneyFormat = this.dataset.moneyFormat;
    this.text = this.querySelector('[data-free-shipping-text]');
    this.track = this.querySelector('.free-shipping-bar__track');
    this.fill = this.querySelector('.free-shipping-bar__fill');
    const checkmarkTemplate = this.querySelector('[data-free-shipping-checkmark]');
    this.checkmarkHTML = checkmarkTemplate ? checkmarkTemplate.innerHTML : '';

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
    }
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
  }

  refresh() {
    fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => this.render(cart.total_price, cart.item_count))
      .catch(() => {});
  }

  render(totalCents, itemCount) {
    const remaining = Math.max(this.threshold - totalCents, 0);
    const progress = Math.min(Math.round((totalCents / this.threshold) * 100), 100);

    this.hidden = itemCount === 0;
    this.track.setAttribute('aria-valuenow', progress);
    this.fill.style.setProperty('--free-shipping-progress', `${progress}%`);

    if (remaining > 0) {
      this.text.innerHTML = `Plus que ${this.formatMoney(
        remaining
      )} pour la <strong>livraison offerte</strong>`;
    } else {
      this.text.innerHTML = `${this.checkmarkHTML}<strong>Livraison offerte</strong> sur cette commande`;
    }
  }

  // Formats cents with the shop's money format (e.g. "€{{amount_with_comma_separator}}"),
  // so amounts look the same as the ones rendered server-side.
  formatMoney(cents) {
    const withSeparators = (value, decimals, thousands, decimal) => {
      const [whole, fraction] = (value / 100).toFixed(decimals).split('.');
      const grouped = whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      return fraction ? grouped + decimal + fraction : grouped;
    };

    return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (match, placeholder) => {
      switch (placeholder) {
        case 'amount':
          return withSeparators(cents, 2, ',', '.');
        case 'amount_no_decimals':
          return withSeparators(cents, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withSeparators(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withSeparators(cents, 0, '.', ',');
        case 'amount_with_space_separator':
          return withSeparators(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return withSeparators(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator':
          return withSeparators(cents, 2, "'", '.');
        default:
          return withSeparators(cents, 2, ',', '.');
      }
    });
  }
}

customElements.define('free-shipping-bar', FreeShippingBar);
